import { Skeleton } from "../ui/skeleton";

export default function StatCard({
  label,
  value,
  helper,
  Icon,
  accent = false,
  loading = false,
  onClick,
  testId,
}) {
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      type={onClick ? "button" : undefined}
      onClick={onClick}
      data-testid={testId}
      className={`text-left bg-white rounded-xl border border-callisto shadow-sm p-4 md:p-5 transition-all ${
        onClick
          ? "cursor-pointer hover:-translate-y-0.5 hover:shadow-md hover:border-callisto-gold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-callisto-gold"
          : ""
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-[0.15em] text-callisto-muted leading-tight">
            {label}
          </p>
          {loading ? (
            <Skeleton className="mt-2 h-8 w-20" />
          ) : (
            <p
              className={`mt-1.5 text-2xl md:text-3xl font-bold tracking-tight ${
                accent ? "text-callisto-gold" : "text-callisto-navy"
              }`}
            >
              {value}
            </p>
          )}
          {helper && (
            <p className="mt-1 text-[11px] uppercase tracking-wider text-callisto-muted">
              {helper}
            </p>
          )}
        </div>
        {Icon && (
          <div
            className={`shrink-0 h-10 w-10 rounded-lg flex items-center justify-center ${
              accent ? "bg-callisto-gold/10 text-callisto-gold" : "bg-callisto-navy/5 text-callisto-navy"
            }`}
          >
            <Icon className="h-5 w-5" strokeWidth={1.75} />
          </div>
        )}
      </div>
    </Comp>
  );
}
